import { AdwordsHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/adwords-handler';
import { BingHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/bing-handler';
import { CJHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/cj-handler';
import { CriteoHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/criteo-handler';
import { FacebookHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/facebook-handler';
import { GAHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/ga-handler';
import { ImpactRadiusHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/impactRadius-handler';
import { ImpactRadiusTransactionHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/impactRadiusTransaction-handler';
import { KlaviyoHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/klaviyo-handler';
import { PepperjamHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/pepperjam-handler';
import { PinterestHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/pinterest-handler';
import { RedditHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/reddit-handler';
import { ShopifyHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/shopify-handler';
import { SnapchatHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/snapchat-handler';
import { TikTokHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/tiktok-handler';
import { TradedeskHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/tradedesk-handler';
import { GA4Handler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/ga4-handler';
import { DV360Handler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/dv360-handler';
import { ProprietarySOTHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/proprietarysot-handler';
import { AmazonHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/amazon-handler';
import { AmazonDSPHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/amazondsp-handler';
import { SteelHouseHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/steelhouse-handler';
import { ApplovinHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/applovin-handler';
import { AmazonSellerHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/amazon-seller-handler';
import { AmazonVendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/amazon-vendor-handler';
import { SearchAds360Handler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/searchads360-handler';
import { PodSightsHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/podsights-handler';
import { TikTokShopHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/tiktok-shop-handler';
import { UniversalAdsHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/universal-ads-handler';
import { LinkedInHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/linkedin-handler';
import { VibeHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vibe-handler';

export const VENDOR_FACTORY = {
  facebook: FacebookHandler,
  criteo: CriteoHandler,
  shopify: ShopifyHandler,
  adwords: AdwordsHandler,
  ga: GAHandler,
  pinterest: PinterestHandler,
  tiktok: TikTokHandler,
  klaviyo: KlaviyoHandler,
  bing: BingHandler,
  snapchat: SnapchatHandler,
  cj: CJHandler,
  tradedesk: TradedeskHandler,
  reddit: RedditHandler,
  impact: ImpactRadiusHandler,
  impactTransaction: ImpactRadiusTransactionHandler,
  pepperjam: PepperjamHandler,
  ga4: GA4Handler,
  dbm: DV360Handler,
  proprietarysot: ProprietarySOTHandler,
  amazon: AmazonHandler,
  'amazon-dsp': AmazonDSPHandler,
  steelhouse: SteelHouseHandler,
  applovin: ApplovinHandler,
  'amazon-seller': AmazonSellerHandler,
  'amazon-vendor': AmazonVendorHandler,
  searchads360: SearchAds360Handler,
  podsights: PodSightsHandler,
  'tiktok-shop': TikTokShopHandler,
  'universal-ads': UniversalAdsHandler,
  linkedin: LinkedInHandler,
  vibe: VibeHandler
};
